export const GET_LOKI_JOBS = "GET_LOKI_JOBS";
export const GET_LOKI_JOBS_SUCCESS = "GET_LOKI_JOBS_SUCCESS";
export const GET_LOKI_JOBS_FAILURE = "GET_LOKI_JOBS_FAILURE";

export const POST_LOKI_SERVICE_MAPPING = "POST_LOKI_SERVICE_MAPPING";
export const POST_LOKI_SERVICE_MAPPING_SUCCESS = "POST_LOKI_SERVICE_MAPPING_SUCCESS";
export const POST_LOKI_SERVICE_MAPPING_FAILURE = "POST_LOKI_SERVICE_MAPPING_FAILURE";
